import { Modal, Button } from 'react-bootstrap'
import { BotUser } from '../../../../API/Users/models'
import { toast } from 'react-hot-toast'
import { deleteBotUser } from '../../../../API/Users/Users'

interface Props {
    show: boolean
    onHide: () => void
    user: BotUser | null
}



export const DeleteUserModal = ({ show, onHide, user }: Props) => {

    const handleDelete = async () => {
        let result = await deleteBotUser({ userId: user?.id ?? '' })
        console.log(result);
        if (result?.msg) {
            toast.success(`Usuario ${user?.name} eliminado correctamente`)
            onHide()
        } else {
            const errorMessage = result?.response?.data?.msg ?? 'Error al eliminar el usuario'
            toast.error(errorMessage)
        }
    }   

    const handleBlockUser = () => {
        console.log(user)
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>

                <Modal.Title>Eliminar Usuario {user?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='d-flex flex-column p-3'>
                <div className='d-flex justify-content-center flex-column gap-1'>
                    <p className='text-center'><b>¿Estás seguro de querer eliminar el usuario {user?.name}?</b></p>
                    <p>Si eliminas el usuario, ya no podrá acceder a su cuenta y se perderán todos los datos asociados a él.</p>


                    <p>Para evitar la perdida de datos relacionados a este usuario o impedir al acceso momentáneo, puedes bloquear el usuario para que no pueda acceder.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>

                <div className='d-flex justify-content-center gap-2'>
                    <Button variant="secondary" onClick={handleBlockUser}>
                        Bloquear
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Eliminar
                    </Button>
                </div>

            </Modal.Footer>
        </Modal>
    )
}
